/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgreementDto } from '../../models/agreement-dto';

export interface AgreementGet$Params {
  languageCode?: string;
  insurerId?: string;
  profileId?: number;
}

export function agreementGet(http: HttpClient, rootUrl: string, params?: AgreementGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AgreementDto>> {
  const rb = new RequestBuilder(rootUrl, agreementGet.PATH, 'get');
  if (params) {
    rb.query('languageCode', params.languageCode, {});
    rb.query('insurerId', params.insurerId, {});
    rb.query('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgreementDto>;
    })
  );
}

agreementGet.PATH = '/v1/Agreement/Get';
